import React from 'react'

import { Skeleton } from 'component-library/content/Skeleton/Skeleton'

import { StyledHeadline } from 'component-library/cards/CardText/CardText.styled'

import { FontScales } from 'component-library/__styling/settings/fontScale'
import { useProduct } from "common/hooks/useProduct"

export interface Props {
    hasBackground?: boolean
    className?: string
    isLarge?: boolean
    fontScale: FontScales
    count?: number // optional count for skeleton
}

export const CardHeadlineSkeleton: React.FC<Props> = props => {
    const product = useProduct()
    const perthNowTheme = product === 'perthnow'
    const sevennewsTheme = product === 'sevennews'
    const hasBackgroundColor = (perthNowTheme || sevennewsTheme) && props.hasBackground

    return (
        <StyledHeadline
            publicationKind="unknown"
            fontScale={props.fontScale}
            className={props.className}
        >
            <Skeleton dark={hasBackgroundColor || false} count={props.count} />
        </StyledHeadline>
    )
}
CardHeadlineSkeleton.displayName = 'CardHeadlineSkeleton'
